import React from 'react'

// Styles
import './Header.scss'

// Components
import Navbar from '../components/Navbars/Navbar'
import { Link } from 'react-router-dom'

const Header = () => {
  return (
    <header className="Header">
      <Navbar>
        <Link to="/" className={'HeaderLogo'}>
          <svg version="1.1" id="francebillt" x="0px" y="0px" viewBox="0 0 435 132">
            <path
              d="M42,92.7l-1.3-2.2c-5.1-9.1-15.8-28.3-16-28.6c-1.2-2.2-1.4-4.6-0.8-6.8c0.6-2.2,2.1-4.2,4.2-5.4l30.3-17
              l5.4,9.6L56,46.6c-4.3,2.4-5.9,7.9-3.4,12.2c1.2,2.2,3.2,3.6,5.4,4.2c2.2,0.6,4.7,0.4,6.8-0.8l7.8-4.4l5.6,10L48,84.8
              C44.9,86.6,42.8,89.5,42,92.7z M66.4,99.1l-8.8-15.7l-7.8,4.4l0,0c0,0,0,0,0,0c-4.3,2.4-5.9,7.9-3.4,12.2s7.9,5.9,12.2,3.4
              c0,0,0,0,0,0l0,0L66.4,99.1z M112.1,55.9c-4.1-0.3-6.1,1.3-6.1,4.9v0.3l6.1,0l0,7.2l-6.1,0l0,21.8l-7.5,0l0-21.8l-4.2,0l0-7.2l4.2,0
              v-0.3c0-8.2,4.6-12.6,13.6-12.1L112.1,55.9z M123.5,66.1c1.4-3.7,4.9-5.6,8.8-5.6l0,8.4c-2.3-0.3-4.3,0.2-6.1,1.4
              c-1.8,1.2-2.7,3.2-2.7,6l0,13.9l-7.5,0l0-29l7.5,0L123.5,66.1z M157.1,61.1l7.5,0l0,29l-7.5,0l0-3.4c-2.3,2.8-5.4,4.2-9.5,4.2
              c-3.9,0-7.2-1.4-10-4.4c-2.7-3-4.1-6.6-4.1-10.9c0-4.3,1.4-7.9,4.1-10.9c2.8-3,6.1-4.5,10-4.5c4.1,0,7.2,1.4,9.5,4.2L157.1,61.1z
               M149.1,83.8c2.3,0,4.2-0.8,5.7-2.3c1.6-1.6,2.3-3.5,2.3-5.9c0-2.4-0.8-4.3-2.3-5.9c-1.5-1.6-3.4-2.3-5.7-2.3
              c-2.3,0-4.2,0.8-5.7,2.3c-1.5,1.5-2.3,3.5-2.3,5.9c0,2.4,0.8,4.3,2.3,5.9C144.8,83,146.8,83.8,149.1,83.8z M194.6,63.4
              c2.1,2.1,3.1,5,3.1,8.8l0,17.8l-7.5,0l0-16.9c0-3.9-2.3-6-5.7-6c-3.9,0-6.4,2.4-6.4,7.2l0,15.7l-7.5,0l0-29l7.5,0l0,3.2
              c1.8-2.7,4.7-4.1,8.6-4.1C189.9,60.2,192.5,61.3,194.6,63.4z M206.1,86.5c-2.9-3-4.4-6.6-4.4-10.9c0-4.4,1.4-7.9,4.3-10.9
              c3-3,6.6-4.4,11-4.4c5.6,0,10.6,2.9,13,7.5l-6.4,3.8c-1.2-2.4-3.7-3.9-6.6-3.9c-4.5,0-7.8,3.3-7.8,8c0,2.3,0.8,4.2,2.2,5.7
              c1.5,1.4,3.3,2.2,5.6,2.2c3,0,5.5-1.5,6.7-3.8l6.5,3.7c-2.5,4.6-7.5,7.5-13.1,7.6C212.8,90.9,209.1,89.4,206.1,86.5z M239.9,78.6
              c1,3.7,3.7,5.5,8.2,5.4c2.8,0,5-1,6.5-2.9l6,3.5c-2.8,4.1-7.1,6.2-12.6,6.2c-4.8,0-8.6-1.4-11.5-4.3c-2.9-2.9-4.4-6.6-4.4-11
              c0-4.4,1.4-8,4.3-10.9c2.8-3,6.6-4.4,11-4.4c4.2,0,7.8,1.4,10.5,4.4c2.8,3,4.2,6.6,4.2,10.9c0,1-0.1,2-0.3,3.1L239.9,78.6z
               M254.6,72.8c-0.9-3.9-3.8-5.9-7.2-5.9c-4,0-6.7,2.2-7.6,5.9L254.6,72.8z M298.9,64.6c2.8,3,4.2,6.6,4.2,10.8
              c0,4.3-1.4,7.9-4.2,10.9c-2.7,3-6.1,4.4-10,4.4c-4.1,0-7.2-1.4-9.4-4.2l0,3.4l-7.5,0l0-40.6l7.5,0l0,15c2.2-2.8,5.3-4.2,9.4-4.2
              C292.8,60.2,296.1,61.7,298.9,64.6z M287.5,83.7c2.3,0,4.2-0.8,5.7-2.3c1.6-1.6,2.3-3.5,2.3-5.9c0-2.4-0.8-4.4-2.3-5.9
              c-1.5-1.6-3.4-2.3-5.7-2.3c-2.3,0-4.2,0.8-5.7,2.3c-1.5,1.5-2.3,3.5-2.3,5.9c0,2.4,0.8,4.3,2.3,5.9
              C283.3,82.9,285.2,83.7,287.5,83.7z M306.3,52.9c0-2.5,2.1-4.6,4.6-4.6c2.6,0,4.6,2.1,4.6,4.6c0,2.5-2.1,4.6-4.6,4.6
              C308.4,57.5,306.3,55.4,306.3,52.9z M307.2,90l0-29l7.5,0l0,29L307.2,90z M320.7,90l0-42.3l7.5,0l0,42.3L320.7,90z M334.2,90l0-42.3
              l7.5,0l0,42.3L334.2,90z M353.3,78.5c1,3.7,3.7,5.5,8.2,5.4c2.8,0,5-1,6.5-2.9l6,3.5c-2.8,4.1-7.1,6.2-12.6,6.2
              c-4.8,0-8.6-1.4-11.5-4.3c-2.9-2.9-4.4-6.6-4.4-11c0-4.4,1.4-8,4.3-10.9c2.8-3,6.6-4.4,11-4.4c4.2,0,7.8,1.4,10.5,4.4
              c2.8,3,4.2,6.6,4.2,10.9c0,1-0.1,2-0.3,3.1L353.3,78.5z M368,72.7c-0.9-3.9-3.8-5.9-7.2-5.9c-4,0-6.7,2.2-7.6,5.9L368,72.7z
               M395.7,68.1l-6.6,0l0,12.1c0,3.1,2.3,3.2,6.6,3l0,6.8c-10.3,1.2-14-1.8-14-9.7l0-12.1l-5,0l0-7.2l5,0l0-5.9l7.5-2.3l0,8.1l6.6,0
              L395.7,68.1z"
            />
          </svg>
        </Link>
      </Navbar>
    </header>
  )
}

export default Header
